import { MabArticleModel, MabArticleResponseModel } from '../models/mab-article.model';

export const buildMabArticlesFromFeed = (rssFeedData: MabArticleResponseModel): MabArticleModel[] => {
  const articles: MabArticleModel[] = [];
  rssFeedData.feed.entry.forEach((element) => {
    // extract HTML content
    const htmlString = element.content['$t'];
    const htmlElement = document.createElement('div');
    htmlElement.innerHTML = htmlString;

    // get first text block as description
    const description = getFirstTextBlock(htmlElement);
    // article image
    const img = htmlElement.getElementsByTagName('img')[0]?.src;
    if (htmlElement.getElementsByTagName('img')[0]) {
      htmlElement.getElementsByTagName('img')[0].remove(); // remove poster image
    }

    // Format images
    const images = Array.from(htmlElement.getElementsByTagName('img'));
    for (const image of images) {
      image.classList.add('max-w-100', 'h-100', 'border-radius-3');
    }

    articles.push({
      id: element.id['$t'],
      description,
      img,
      title: element.title['$t'],
      content: decodeHtml(htmlElement.innerHTML),
      updated: new Date(element.updated['$t']),
    });

    articles.sort((a, b) => b.updated.getTime() - a.updated.getTime());
  });
  return articles;
};

// Due to iOS - does not support .getHtml()
const decodeHtml = (html): string => {
  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
};

const getFirstTextBlock = (element: HTMLElement): string => {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
    acceptNode: (node) => {
      const text = node.textContent?.trim();
      if (!text || text === '\n') return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  const firstNode = walker.nextNode();
  return firstNode?.textContent?.trim() || '';
};
